/* global debounce, trapFocus */

function ccEmitCartChange(detail) {
  if (typeof window.ccDispatchCartChange === 'function') {
    window.ccDispatchCartChange(detail);
  } else {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, detail: detail || {} }));
  }
}

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      
      // Initialize free product validation
      this.initFreeProductValidation();
      
      // Initialize processing flags
      this.isAddingFreeProduct = false;
      
      // Set up global free product lock to prevent multiple additions from different sources
      if (!window.freeProductLock) {
        window.freeProductLock = {
          isProcessing: false,
          variantId: null
        };
      }
      
      if (this.dataset.empty === 'false') {
        this.init();
      } else {
        // Cart is empty on page load, hide recommendations if they exist
        setTimeout(() => {
          const recommendations = document.getElementById('cart-recommendations');
          if (recommendations) {
            recommendations.style.display = 'none';
          }
        }, 100);
      }
    }

    initFreeProductValidation() {
      // Master freebies toggle — when off, null out all variant IDs so no freebie logic runs
      const freebiesEnabled = theme.settings.cartProgressBar?.freebiesEnabled === true;

      // Freebie 2 (auto-add at milestone 2)
      const freebie2Enabled = freebiesEnabled && theme.settings.cartProgressBar?.freebie2Enabled !== false;
      const variantIdString = freebie2Enabled ? theme.settings.cartProgressBar?.freeProductVariantId : null;
      this.freeProductVariantId = variantIdString ? parseInt(variantIdString, 10) : null;

      // Freebie 1 (auto-add at threshold)
      const freebie1Enabled = freebiesEnabled && theme.settings.cartProgressBar?.freebie1Enabled !== false;
      const freebie3IdString = freebie1Enabled ? theme.settings.cartProgressBar?.freebie3VariantId : null;
      this.freebie3VariantId = freebie3IdString ? parseInt(freebie3IdString, 10) : null;
      this.freebie3Threshold = freebiesEnabled ? (theme.settings.cartProgressBar?.freebie3Threshold || 0) * 100 : 0;

      // Only proceed if we have a free product configured
      if (!this.freeProductVariantId || this.freeProductVariantId === 0) {
        return;
      }
      
      
      // Listen for quantity input changes
      document.addEventListener('input', (event) => {
        if (event.target.matches('.cart-item__quantity input')) {
          const cartItem = event.target.closest('.cart-item');
          const variantId = cartItem?.dataset.variantId;
          
          if (variantId === this.freeProductVariantId) {
            const newQuantity = parseInt(event.target.value);
            
            if (newQuantity > 1) {
              event.target.value = 1;
              // Trigger quantity correction
              setTimeout(() => {
                this.correctFreeProductQuantity(cartItem, 1);
              }, 100);
            }
          }
        }
      });

      // Set up global fetch interceptor to prevent duplicate free product additions
      this.setupGlobalFetchInterceptor();
    }

    async correctFreeProductQuantity(cartItem, correctQuantity) {
      try {
        // Use line key if available, otherwise fall back to index
        const lineKey = cartItem.dataset.lineKey;
        const lineItemIndex = cartItem.dataset.index;
        const line = lineKey || lineItemIndex;

        const response = await fetch(theme.routes.cartChange, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            line: line,
            quantity: correctQuantity
          })
        });

        if (response.ok) {
        } else {
        }
      } catch (error) {
      }
    }

    setupGlobalFetchInterceptor() {
      // Only set up interceptor once globally
      if (window.freeProductFetchInterceptorSetup) {
        return;
      }
      window.freeProductFetchInterceptorSetup = true;

      const originalFetch = window.fetch;
      window.fetch = async (url, options) => {
        // Check if this is a cart add request with our free product
        if (url.includes('cart/add') && options && options.body) {
          try {
            let bodyData;
            if (options.body instanceof FormData) {
              const id = options.body.get('id');
              if (id === this.freeProductVariantId) {
                if (this.checkIfFreeProductInCart()) {
                  return new Response(JSON.stringify({ status: 'success', message: 'Product already in cart' }), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                  });
                }
              }
            } else if (typeof options.body === 'string') {
              bodyData = JSON.parse(options.body);
              if (bodyData.items && bodyData.items.some(item => item.id === this.freeProductVariantId)) {
                if (this.checkIfFreeProductInCart()) {
                  return new Response(JSON.stringify({ status: 'success', message: 'Product already in cart' }), {
                    status: 200,
                    headers: { 'Content-Type': 'application/json' }
                  });
                }
              }
            }
          } catch (error) {
          }
        }
        
        return originalFetch(url, options);
      };
    }

    checkIfFreeProductInCart() {
      const cartItems = document.querySelectorAll('.cart-item');
      for (let item of cartItems) {
        const variantId = item.dataset.variantId;
        if (variantId === this.freeProductVariantId) {
          return true;
        }
      }
      return false;
    }

    async checkAndHandleFreeProductImmediately(cartData) {
      // Only proceed if we have a free product configured
      if (!this.freeProductVariantId || this.freeProductVariantId === '0') {
        return cartData;
      }

      
      // Use the simplified milestone logic like other files
      return await this.handleFreeProductMilestone(cartData);
    }

    /**
     * Handle free product milestone logic
     * @param {Object} cartData - Current cart data
     */
    async handleFreeProductMilestone(cartData) {
      window.__lastFreebieCheckMs = Date.now(); // FIX: stamp prevents redundant 2nd-pass check
      const _fpmLog = (step) => {
        const ms = window.__atcT0 ? ` (+${(performance.now() - window.__atcT0).toFixed(0)}ms)` : '';
      };
      _fpmLog('handleFreeProductMilestone START');
      
      // Calculate cart total excluding free product
      const cartTotalExcludingFreeProduct = this.calculateCartTotalExcludingFreeProduct(cartData);
      
      // Check if free product is currently in cart
      const freeProductItem = cartData.items.find(item => item.variant_id === this.freeProductVariantId);
      let hasFreeProduct = !!freeProductItem;
      
      if (freeProductItem) {
      }
      
      // Check if free product is in DOM
      const domFreeProduct = document.querySelector(`[data-variant-id="${this.freeProductVariantId}"]`);
      
      // Check for 3rd milestone popup products to remove
      const milestone3PopupItems = cartData.items.filter(item => 
        item.properties && item.properties._3rd_milestone_popup === 'true'
      );
      
      
      // Get freebie thresholds — use dedicated freebie settings, fall back to milestone values
      const milestone2Threshold = (theme.settings.cartProgressBar?.freebie2Threshold || theme.settings.cartProgressBar?.milestone2 || 68) * 100;
      const milestone3Threshold = (theme.settings.cartProgressBar?.popupThreshold || theme.settings.cartProgressBar?.milestone3 || 100) * 100;
      
      
      // Handle removals: Check if both freebies need to be removed (below both thresholds)
      let updatedCartData = cartData;
      let needsFreebie1Removal = false;
      
      // Check if both need to be removed - do them together for efficiency
      const needsMilestone3Removal = cartTotalExcludingFreeProduct < milestone3Threshold && milestone3PopupItems.length > 0;
      needsFreebie1Removal = cartTotalExcludingFreeProduct < milestone2Threshold && hasFreeProduct;
      
      // Remove 3rd milestone popup products if below threshold
      if (needsMilestone3Removal) {
        // Clear the manually-removed flag since this is an automatic removal (cart dropped below threshold)
        // This allows popup to show again if user reaches milestone 3 again later
        sessionStorage.removeItem('milestone3-popup-manually-removed');
        // Clear the dismissed without selection flag as well
        sessionStorage.removeItem('milestone3-popup-dismissed-without-selection');
        _fpmLog('removeMilestone3PopupProducts START');
        updatedCartData = await this.removeMilestone3PopupProducts(cartData, milestone3PopupItems);
        _fpmLog('removeMilestone3PopupProducts DONE');
        // Update hasFreeProduct from the returned cart data (no need to re-fetch)
        if (updatedCartData && updatedCartData.items) {
          const freebie1AfterRemoval = updatedCartData.items.find(item => item.variant_id === this.freeProductVariantId);
          hasFreeProduct = !!freebie1AfterRemoval;
          needsFreebie1Removal = cartTotalExcludingFreeProduct < milestone2Threshold && hasFreeProduct;
        }
      }
      
      // Milestone logic: Add free product at milestone2 threshold, remove below threshold
      // Check this AFTER milestone 3 removal to ensure both are handled
      if (cartTotalExcludingFreeProduct >= milestone2Threshold) {
        // Should have free product
        if (!hasFreeProduct) {
          // FIX: fire in background — drawer shows immediately, freebie appears after
          _fpmLog('addFreeProductImmediately START (background)');
          this.addFreeProductImmediately().then(addResult => {
            _fpmLog('addFreeProductImmediately background DONE');
            if (addResult) {
              const cartDrawerEl = document.querySelector('cart-drawer');
              if (cartDrawerEl?.refreshCartDrawer) cartDrawerEl.refreshCartDrawer(true);
            }
          });
        } else {
        }
      } else {
        // Should not have free product - remove if it exists
        if (needsFreebie1Removal || hasFreeProduct) {
          // Remove freebie 1 using the updated cart data (after milestone 3 removal if it happened)
          _fpmLog('removeFreeProductImmediately START');
          const removeResult = await this.removeFreeProductImmediately(updatedCartData);
          _fpmLog('removeFreeProductImmediately DONE');
          updatedCartData = removeResult || updatedCartData;
        } else {
        }
      }

      // Freebie 3: variant-ID-based, independent of freebie 1 and milestone popup
      if (this.freebie3VariantId && this.freebie3Threshold > 0) {
        const freebie3Item = updatedCartData.items?.find(item => item.variant_id === this.freebie3VariantId);
        const hasFreebie3 = !!freebie3Item;

        if (cartTotalExcludingFreeProduct >= this.freebie3Threshold) {
          if (!hasFreebie3) {
            _fpmLog('addFreebie3Immediately START');
            const freebie3Result = await this.addFreebie3Immediately();
            _fpmLog('addFreebie3Immediately DONE');
            updatedCartData = freebie3Result || updatedCartData;
          } else {
          }
        } else {
          if (hasFreebie3) {
            _fpmLog('removeAllByVariantId (freebie3) START');
            const removeResult = await this.removeAllByVariantId(this.freebie3VariantId);
            _fpmLog('removeAllByVariantId (freebie3) DONE');
            updatedCartData = removeResult || updatedCartData;
          } else {
          }
        }
      }

      return updatedCartData;
    }

    async fetchFreshCartData() {
      try {
        const response = await fetch(`${theme.routes.cart}.js`);
        if (response.ok) {
          const freshCartData = await response.json();
          return freshCartData;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    }

    getMilestones() {
      // Get milestone amounts from global theme settings (in dollars) and convert to cents
      const milestone1 = (theme.settings.cartProgressBar?.milestone1 || 5) * 100;
      const milestone2 = (theme.settings.cartProgressBar?.milestone2 || 10) * 100;
      const milestone3 = (theme.settings.cartProgressBar?.milestone3 || 15) * 100;
      
      return [0, milestone1, milestone2, milestone3];
    }

    calculateCurrentMilestone(cartTotal, milestones) {
      for (let i = milestones.length - 1; i >= 0; i--) {
        if (cartTotal >= milestones[i]) {
          return i;
        }
      }
      return 0;
    }

    calculateCartTotalExcludingFreeProduct(cartData) {
      if (!cartData || !cartData.items) {
        return 0;
      }

      // Calculate cart total excluding free product and milestone popup products

      // Use the exact same simple calculation as your working code
      // Also exclude products with _3rd_milestone_popup property
      const totalExcludingFreeProduct = cartData.items
        .filter(item => {
          const isFreeProduct = item.variant_id === this.freeProductVariantId;
          const isFreebie3 = this.freebie3VariantId && item.variant_id === this.freebie3VariantId;
          const isMilestonePopupProduct = item.properties && item.properties._3rd_milestone_popup === 'true';
          const shouldExclude = isFreeProduct || isFreebie3 || isMilestonePopupProduct;

          if (shouldExclude) {
          }

          return !shouldExclude;
        })
        .reduce((total, item) => total + (item.final_line_price), 0);
      
      
      return totalExcludingFreeProduct;
    }

    syncCartDrawerEmptyLayout(isEmpty) {
      if (!this.cartDrawer) return;

      const drawerContent = this.cartDrawer.querySelector('.cart-drawer__content');
      if (drawerContent) {
        drawerContent.classList.toggle('cart-drawer__content--empty', isEmpty);
      }
    }

    async addFreeProductImmediately() {
      // Check global lock first
      if (window.freeProductLock.isProcessing) {
        return null;
      }
      
      // Prevent multiple simultaneous additions from this instance
      if (this.isAddingFreeProduct) {
        return null;
      }
      
      // Set global and local locks
      window.freeProductLock.isProcessing = true;
      window.freeProductLock.variantId = this.freeProductVariantId;
      this.isAddingFreeProduct = true;
      
      
      try {
        
        // CRITICAL: Single atomic check right before adding - fetch fresh cart and check
        const freshCartCheck = await fetch(`${theme.routes.cart}.js`);
        if (!freshCartCheck.ok) {
          return null;
        }
        
        let freshCartData = await freshCartCheck.json();
        const existingFreeProductItem = freshCartData.items.find(item => item.variant_id.toString() === this.freeProductVariantId.toString());
        
        if (existingFreeProductItem) {
          // Check if it's already a freebie (has freebie properties)
          const isAlreadyFreebie = existingFreeProductItem.properties && 
            (existingFreeProductItem.properties._free_product === 'true' || 
             existingFreeProductItem.properties['_free_product'] === 'true');
          
          if (isAlreadyFreebie) {
            return freshCartData; // Return current cart data, don't add
          } else {
            // Variant exists but NOT as a freebie - remove it first, then add as freebie
            const updatedCart = await this.removeAllByVariantId(this.freeProductVariantId);
            // Use the updated cart data for the rest of the function
            freshCartData = updatedCart;
          }
        }
        
        
        // Get sections to include in the request
        const sections = this.getSectionsToRender().map((section) => section.section);
        // Deduplicate sections to prevent 400 errors
        const uniqueSections = [...new Set(sections)];
        const sectionsString = uniqueSections.join(',');
        
        // Use FormData like product-form.js does
        const formData = new FormData();
        formData.append('id', this.freeProductVariantId);
        formData.append('quantity', '1');
        
        // Add Kite promo properties for first freebie
        formData.append('properties[_free_product]', 'true');
        formData.append('properties[_rule_id]', 'SPEND_X_0');
        formData.append('properties[_kite_promo_name]', 'Freebie 1');
        
        formData.append('sections', sectionsString);
        formData.append('sections_url', window.location.pathname);
        
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        if (response.ok) {
          // The /cart/add endpoint returns just the new line item, not full cart
          
          // FIX: /cart/add returned 200 so cart is already updated — no delay needed.
          // Parallelize sections + cart.js fetches (independent requests).

          let sectionsData = {};
          const sectionsUrl = window.location.origin + `?sections=${sectionsString}`;

          let cartResponse_;
          try {
            const [sectionsResponse, cartJson] = await Promise.all([
              fetch(sectionsUrl),
              CartItems.fetchCartJson()
            ]);
            cartResponse_ = cartJson;
            if (!sectionsResponse.ok) {
            } else {
              sectionsData = await sectionsResponse.json();
            }
          } catch (sectionError) {
            cartResponse_ = cartResponse_ || await CartItems.fetchCartJson();
          }
          if (!cartResponse_) {
            return null;
          }
          
          const cartData = cartResponse_;
          
          // Check if freebie is in cart
          const returnedFreebie = cartData.items.find(item => item.variant_id === this.freeProductVariantId);
          
          if (returnedFreebie) {
          }
          
          // Merge cart data with sections
          const completeCartData = {
            ...cartData,
            sections: sectionsData
          };
          
          // Update cart UI (drawer or page) so the freebie line appears when added from ATC / product-form
          if (completeCartData.sections && Object.keys(completeCartData.sections).length > 0) {
            this.updateCartSections(completeCartData);
          }
          return completeCartData;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      } finally {
        // Always reset both local and global flags
        this.isAddingFreeProduct = false;
        window.freeProductLock.isProcessing = false;
        window.freeProductLock.variantId = null;
      }
    }

    async removeFreeProductImmediately(cartData) {
      
      try {
        // Check global lock to prevent conflicts - but don't wait, just skip if locked
        if (window.freeProductLock && window.freeProductLock.isProcessing) {
          return cartData;
        }
        
        // Check if free product is actually in the cart
        if (!cartData || !cartData.items) {
          cartData = await fetch(`${theme.routes.cart}.js`).then(r => r.json());
        }

        const freeProductItem = cartData.items.find(item => item.variant_id === this.freeProductVariantId);
        
        if (!freeProductItem) {
          return cartData;
        }
        
        
        // Set lock for removal operation
        if (window.freeProductLock) {
          window.freeProductLock.isProcessing = true;
          window.freeProductLock.variantId = this.freeProductVariantId;
        }
        
        
        // Use the improved removal function
        const updatedCart = await this.removeAllByVariantId(this.freeProductVariantId);
        return updatedCart;
        
      } catch (error) {
        return cartData;
      } finally {
        // Release lock immediately after removal (no delay)
        if (window.freeProductLock) {
          window.freeProductLock.isProcessing = false;
          window.freeProductLock.variantId = null;
        }
      }
    }

    async addFreebie3Immediately() {
      if (window.freeProductLock?.isProcessing) {
        return null;
      }

      if (window.freeProductLock) {
        window.freeProductLock.isProcessing = true;
        window.freeProductLock.variantId = this.freebie3VariantId;
      }

      try {
        // Final check before adding
        const freshCart = await fetch(`${theme.routes.cart}.js`).then(r => r.json());
        const existing = freshCart.items.find(item => item.variant_id.toString() === this.freebie3VariantId.toString());

        if (existing) {
          const isAlreadyFreebie = existing.properties?._free_product === 'true';
          if (isAlreadyFreebie) {
            return freshCart;
          }
          // Exists as a paid item — remove it first, then add as freebie
          await this.removeAllByVariantId(this.freebie3VariantId);
        }

        const sections = this.getSectionsToRender().map(s => s.section);
        const sectionsString = [...new Set(sections)].join(',');

        const formData = new FormData();
        formData.append('id', this.freebie3VariantId);
        formData.append('quantity', '1');
        formData.append('properties[_free_product]', 'true');
        formData.append('properties[_rule_id]', 'SPEND_X_0');
        formData.append('properties[_kite_promo_name]', 'Free Mango Box');
        formData.append('sections', sectionsString);
        formData.append('sections_url', window.location.pathname);

        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        if (response.ok) {
          // FIX: parallelize sections + cart.js — no delay needed after 200 OK from /cart/add
          let sectionsData = {};
          let cartData;
          try {
            const sectionsUrl = window.location.origin + `?sections=${sectionsString}`;
            const [sectionsResponse, cartJson] = await Promise.all([
              fetch(sectionsUrl),
              CartItems.fetchCartJson()
            ]);
            cartData = cartJson;
            if (sectionsResponse.ok) sectionsData = await sectionsResponse.json();
          } catch (e) {
            cartData = cartData || await CartItems.fetchCartJson();
          }
          if (!cartData) return null;
          const completeCartData = { ...cartData, sections: sectionsData };
          if (Object.keys(sectionsData).length > 0) this.updateCartSections(completeCartData);
          return completeCartData;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      } finally {
        if (window.freeProductLock) {
          window.freeProductLock.isProcessing = false;
          window.freeProductLock.variantId = null;
        }
      }
    }

    async removeMilestone3PopupProducts(cartData, popupItems) {
      try {
        // Check global lock to prevent conflicts - but don't wait, just skip if locked
        if (window.freeProductLock && window.freeProductLock.isProcessing) {
          return cartData;
        }
        
        // Set lock for removal operation
        if (window.freeProductLock) {
          window.freeProductLock.isProcessing = true;
          window.freeProductLock.variantId = 'milestone3_popup';
        }
        
        
        // Use the cart data we already have instead of fetching again
        const currentCartCheck = cartData && cartData.items ? cartData : await fetch('/cart.js').then(r => r.json()).catch(() => null);
        if (!currentCartCheck || currentCartCheck.items.length === 0) {
          return currentCartCheck || cartData;
        }
        
        // Filter to only items that still exist in cart
        const itemsToRemove = popupItems.filter(item => {
          if (!item.key || !item.variant_id) {
            return false;
          }
          // Check if item still exists in current cart
          const stillExists = currentCartCheck.items.some(cartItem => cartItem.key === item.key);
          if (!stillExists) {
            return false;
          }
          return true;
        });
        
        if (itemsToRemove.length === 0) {
          return currentCartCheck;
        }
        
        
        // Remove all popup products in parallel for speed (using Promise.all)
        const removalPromises = itemsToRemove.map(async (item) => {
          try {
            
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            });

            if (!response.ok) {
              const errorText = await response.text();
              // If 400/404, item was already removed - that's okay
              if (response.status === 400 || response.status === 404) {
                return null;
              }
              throw new Error(`HTTP error! status: ${response.status}, ${errorText}`);
            }

            const result = await response.json();
            return result;
            
          } catch (error) {
            return null; // Return null on error, we'll continue
          }
        });
        
        // Wait for all removals to complete
        await Promise.all(removalPromises);
        
        // Fetch updated cart data (single fetch instead of multiple)
        const updatedCart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
        
        // Fetch sections in parallel with cart data for efficiency
        const sections = this.getSectionsToRender().map((section) => section.section);
        const sectionsString = [...new Set(sections)].join(',');
        if (sectionsString && updatedCart) {
        try {
          const sectionsUrl = window.location.origin + `?sections=${sectionsString}`;
          const sectionsResponse = await fetch(sectionsUrl);
          if (sectionsResponse.ok) {
            updatedCart.sections = await sectionsResponse.json();
          }
        } catch (error) {
          }
        }
        
        // Clear session flags to allow popup to show again
        sessionStorage.removeItem('milestone3-popup-product-selected');
        sessionStorage.removeItem('milestone3-popup-shown');
        
        // Update cart bubble count
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && updatedCart) {
          const countElement = cartIconBubble.querySelector('.header__cart-count-number');
          const countText = cartIconBubble.querySelector('.visually-hidden');
          
          if (countElement) {
            countElement.textContent = updatedCart.item_count;
          }
          
          if (countText) {
            const itemText = updatedCart.item_count === 1 ? 'item' : 'items';
            countText.textContent = `${updatedCart.item_count} ${itemText}`;
          }
          
          // Show/hide cart count based on whether cart is empty
          const cartCountContainer = cartIconBubble.querySelector('.header__cart-count');
          if (cartCountContainer) {
            if (updatedCart.item_count > 0) {
              cartCountContainer.style.display = '';
            } else {
              cartCountContainer.style.display = 'none';
            }
          }
        }
        
        // Trigger UI updates - refresh cart items on cart page
        if (window.location.pathname === theme.routes.cart) {
          this.refreshCartItems();
        }
        
        // Update cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.refreshCartDrawer) {
          cartDrawer.refreshCartDrawer();
        }
        
        // Dispatch cart change event for other components
        ccEmitCartChange({
          source: 'milestone3_removal',
          action: 'popup_products_removed',
          removedItems: popupItems.length,
          cart: updatedCart || cartData
        });
        
        return updatedCart || cartData;
        
      } catch (error) {
        return cartData;
      } finally {
        // Release lock immediately after milestone 3 removal (no delay)
        if (window.freeProductLock) {
          window.freeProductLock.isProcessing = false;
          window.freeProductLock.variantId = null;
        }
      }
    }

    /**
     * Improved removal function using line item keys
     * @param {number} variantId - The variant ID to remove
     * @returns {Promise<Object>} Updated cart data
     */
    async removeAllByVariantId(variantId) {
      
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        let lastResponseData = null;
        let removedCount = 0;
        
        // Keep removing until no more items with this variant ID are found
        // This handles cases where line indices shift after each removal
        while (true) {
          // 1) Get fresh cart data before each removal attempt
          const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

          // 2) Find the first matching item and get its line index (1-based)
          const itemIndex = cart.items.findIndex(item => item.variant_id === variantId);
          
          
          if (itemIndex === -1) {
            break; // No more items to remove
          }

          const item = cart.items[itemIndex];
          
          // CRITICAL: Verify the item actually matches the variant ID we're looking for
          if (item.variant_id !== variantId) {
            break;
          }
          
          
          // Check if this might be the last item to remove
          const remainingItems = cart.items.filter(item => item.variant_id === variantId);
          const isLastItem = remainingItems.length === 1;
          
          // Build request body - use key (id) as primary method (more reliable than line index)
          // The key is stable and doesn't change when other items are removed
          const requestBody = { 
            id: item.key, // Use key (id) - this is the most reliable method
            quantity: 0
          };
          
          // Only include sections on the last removal to get the final updated sections
          if (isLastItem) {
            requestBody.sections = [...new Set(sections)];
            requestBody.sections_url = window.location.pathname;
          }
          
          
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
          });
          
          if (!res.ok) {
            // Get error details
            const errorText = await res.text();
            let errorData;
            try {
              errorData = JSON.parse(errorText);
            } catch (e) {
              errorData = { message: errorText };
            }

            // Fetch fresh cart to check if item still exists
            const freshCart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
            const itemStillExists = freshCart.items.some(i => i.key === item.key);
            
            if (!itemStillExists) {
              // Item was already removed, continue
              break;
            }
            
            // Item still exists but key removal failed - this is a problem
            // Don't use line index fallback as it's unreliable and can remove wrong items
            
            // Try one more time with the key (in case it was a temporary issue)
            const retryRes = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(requestBody)
            });
            
            if (!retryRes.ok) {
              const retryErrorText = await retryRes.text();
              // Break to prevent infinite loop
              break;
            } else {
              removedCount++;
              if (isLastItem) {
                lastResponseData = await retryRes.json();
              }
            }
          } else {
            removedCount++;
            
            // Store the last response data (which should include sections)
            if (isLastItem) {
              lastResponseData = await res.json();
            }
          }
        }

        // 4) Return the response data with sections if available, otherwise fetch fresh cart
        if (lastResponseData && lastResponseData.sections) {
          return lastResponseData;
        } else {
          const finalCart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
          return finalCart;
        }
        
      } catch (error) {
        throw error;
      }
    }

    /**
     * Update the cart drawer count element
     * @param {number} itemCount - The current item count in the cart
     */
    updateCartDrawerCount(itemCount) {
      // Try to find the drawer count element - it's in the cart drawer header
      const cartDrawer = document.getElementById('cart-drawer');
      if (!cartDrawer) {
        return;
      }
      
      let drawerCount = cartDrawer.querySelector('.cart-drawer__count');
      
      // If element doesn't exist, it might be because the header wasn't rendered with the count
      // In that case, we need to find the header and create/add the count element
      if (!drawerCount) {
        const drawerHeader = cartDrawer.querySelector('.drawer__header');
        if (drawerHeader) {
          const headerTitleContainer = drawerHeader.querySelector('.flex.items-center');
          if (headerTitleContainer) {
            // Create the count element if it doesn't exist
            drawerCount = document.createElement('span');
            drawerCount.className = 'cart-drawer__count text-sm font-medium';
            headerTitleContainer.appendChild(drawerCount);
          }
        }
      }
      
      if (drawerCount) {
        if (itemCount > 0) {
          const itemText = itemCount === 1 ? 'Item' : 'Items';
          drawerCount.textContent = `(${itemCount} ${itemText})`;
          drawerCount.hidden = false;
          drawerCount.style.display = '';
        } else {
          drawerCount.textContent = '';
          drawerCount.hidden = true;
          drawerCount.style.display = 'none';
        }
      } else {
      }
    }

    updateCartSections(cartData) {
      // Update the cart sections with the new cart data
      if (!cartData.sections || typeof cartData.sections !== 'object') return;
      this.getSectionsToRender().forEach((section) => {
        const sectionEl = document.getElementById(section.id);
        if (!sectionEl) return;
        const sectionHtml = cartData.sections[section.section];
        if (!sectionHtml) return;

        const { selector } = section;
        const el = sectionEl.querySelector(selector) || sectionEl;
        el.innerHTML = CartItems.getElementHTML(sectionHtml, selector);
      });

      // Update the cart drawer count after all sections are updated
      // This ensures the count is updated even if the header was replaced
      if (this.cartDrawer) {
        this.updateCartDrawerCount(cartData.item_count);
      }

      // Update the main cart page title count
      const cartTitle = document.querySelector('.js-cart-title');
      if (cartTitle && !this.cartDrawer) {
        let cartCount = cartTitle.querySelector('.cart__count');
        if (cartData.item_count > 0) {
          if (!cartCount) {
            cartCount = document.createElement('span');
            cartCount.className = 'cart__count';
            cartTitle.appendChild(document.createTextNode(' '));
            cartTitle.appendChild(cartCount);
          }
          cartCount.textContent = `(${cartData.item_count})`;
        } else if (cartCount) {
          cartCount.remove();
        }
      }

      ccEmitCartChange({
        cart: cartData,
        newTotalQuantity: cartData.item_count,
        newTotalPrice: cartData.total_price
      });
    }

    triggerFreeProductCheck() {
      // Only trigger if we have a free product configured
      if (!this.freeProductVariantId || this.freeProductVariantId === '0') {
        return;
      }

      
      // Dispatch a custom event that the cart progress bar can listen to
      document.dispatchEvent(new CustomEvent('on:free-product:check', {
        bubbles: true,
        detail: { 
          source: 'cart-items',
          freeProductVariantId: this.freeProductVariantId 
        }
      }));
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        const qtyInput = item.querySelector('.qty-input__input');
        if (qtyInput) {
          this.currentQuantities[item.dataset.variantId] = Number(qtyInput.value);
        }
      });

      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));

      CartItems.fetchCartJson()
        .then((cartData) => {
          if (cartData) CartItems.syncCartItemDebug(cartData, this, 'cart-items-init');
        })
        .catch(() => {});
      
      // Check recommendations visibility on page load (with delay to allow product-recommendations to load)
      setTimeout(() => {
        this.checkRecommendationsVisibility();
      }, 600);
      
      // Also watch for changes to recommendations element (in case they load later)
      this.observeRecommendations();
      
      // Check free product on cart initialization (with delay to ensure cart is fully loaded)
      setTimeout(async () => {
        try {
          const cartResponse = await fetch(`${theme.routes.cart}.js`);
          if (cartResponse.ok) {
            const cartData = await cartResponse.json();
            CartItems.syncCartItemDebug(cartData, this, 'cart-items-init-delayed');
            await this.checkAndHandleFreeProductImmediately(cartData);
          }
        } catch (error) {
        }
      }, 1000);
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      // Use line key if available, otherwise fall back to index
      const lineKey = evt.target.dataset.lineKey;
      const lineIndex = evt.target.dataset.index;
      const line = lineKey || lineIndex;
      this.updateQuantity(line, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      const lineKey = evt.target.dataset.lineKey;
      const lineIndex = evt.target.dataset.index;
      if (!lineKey && !lineIndex) return;
      const line = lineKey || lineIndex;
      this.updateQuantity(line, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {string|number} line - Line item key (preferred) or index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      
      if (Shopify.designMode) this.cartDrawer = document.getElementById('cart-drawer');

      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      // Try to find line item by key first, then by index to get the actual index for error element
      let lineItem = null;
      let actualLineIndex = null;
      if (typeof line === 'string') {
        // Line is a key, find by data-line-key attribute.
        // Scope to the cart line row (.cart-item) inside THIS cart-items element —
        // other places (e.g. the Rakhi product card's quick-quantity stepper) also
        // stamp data-line-key, and a document-wide query can return one of those
        // instead of the cart row, leaving variantId as NaN and breaking the
        // on:line-item:change sync back to the product card.
        lineItem = this.querySelector(`.cart-item[data-line-key="${line}"]`)
          || document.querySelector(`.cart-item[data-line-key="${line}"]`);
        if (lineItem) {
          actualLineIndex = lineItem.dataset.lineIndex || lineItem.id.replace('cart-item-', '');
        }
      }
      if (!lineItem) {
        // Fall back to finding by index
        lineItem = document.getElementById(`cart-item-${line}`);
        actualLineIndex = line;
      }

      // Get product info for logging
      const variantId = lineItem ? Number(lineItem.dataset.variantId) : null;
      const productTitle = lineItem ? (lineItem.querySelector('.cart-item__title')?.textContent?.trim() || 'Unknown') : 'Unknown';
      const currentQuantity = lineItem ? (lineItem.querySelector('.qty-input__input')?.value || 'Unknown') : 'Unknown';
      const isMilestone3PopupItem = lineItem ? (lineItem.dataset.milestone3Popup === 'true') : false;
      
      
      // Check if user is manually removing Freebie 2 (Milestone 3 popup product)
      if (quantity === 0 && isMilestone3PopupItem) {
        sessionStorage.setItem('milestone3-popup-manually-removed', 'true');
      }

      // Use actual line index for loading state and error element
      const loadingIdentifier = actualLineIndex || line;
      this.enableLoading(loadingIdentifier);

      // Find error element - it uses the index format
      const lineErrorsId = `line-item-error-${actualLineIndex || line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      // Also try to find error element within the line item if not found by ID
      const lineErrorsElement = lineErrors || (lineItem ? lineItem.querySelector('.cart-item__error') : null);
      
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      
      // Shopify API: use 'id' for line item key (contains ':'), 'line' (integer) for index
      const isLineKey = typeof line === 'string' && line.includes(':');
      const requestBody = isLineKey
        ? { id: line, quantity, sections: [...new Set(sections)], sections_url: window.location.pathname }
        : { line: parseInt(line, 10), quantity, sections: [...new Set(sections)], sections_url: window.location.pathname };
      
      this.fetchRequestOpts.body = JSON.stringify(requestBody);

      try {
        const oldTotalQuantity = this.currentTotalItemCount;
        
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        // Shopify silently clamps the quantity to what's actually available (inventory or
        // max-per-order rules) and still returns 200. Compare what we asked for with what we
        // got so the customer gets told, instead of the quantity just snapping to a lower number.
        const requestedQuantity = parseInt(quantity, 10);
        let acceptedQuantity = null;
        if (Number.isInteger(requestedQuantity) && requestedQuantity > 0) {
          const acceptedLine = isLineKey
            ? data.items.find((item) => item.key === line)
            : data.items[parseInt(line, 10) - 1];
          if (acceptedLine && acceptedLine.quantity < requestedQuantity) {
            acceptedQuantity = acceptedLine.quantity;
          }
        }

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartSummary = document.getElementById('cart-summary');
          if (cartSummary) cartSummary.hidden = true;
        }

        // First re-render: Show the cart update immediately
        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        // Update the cart drawer count after all sections are updated
        // This ensures the count is updated even if the header was replaced
        if (this.cartDrawer) {
          this.updateCartDrawerCount(data.item_count);
        }

        // Update the main cart page title count
        const cartTitle = document.querySelector('.js-cart-title');
        if (cartTitle && !this.cartDrawer) {
          let cartCount = cartTitle.querySelector('.cart__count');
          const finalItemCount = newTotalQuantity;
          if (finalItemCount > 0) {
            if (!cartCount) {
              cartCount = document.createElement('span');
              cartCount.className = 'cart__count';
              cartTitle.appendChild(document.createTextNode(' '));
              cartTitle.appendChild(cartCount);
            }
            cartCount.textContent = `(${finalItemCount})`;
          } else if (cartCount) {
            cartCount.remove();
            // Remove the space before the count as well
            const lastNode = cartTitle.lastChild;
            if (lastNode && lastNode.nodeType === Node.TEXT_NODE && lastNode.textContent === ' ') {
              lastNode.remove();
            }
          }
        }

        ccEmitCartChange({
          cart: data,
          newTotalQuantity: newTotalQuantity,
          newTotalPrice: data.total_price
        });

        // Trigger free product check after cart update
        this.triggerFreeProductCheck();

        // Second re-render: Check and handle free product, then re-render again
        let updatedCartData = await this.checkAndHandleFreeProductImmediately(data);
        // Ensure updatedCartData is set even if checkAndHandleFreeProductImmediately returns null/undefined
        if (!updatedCartData) {
          updatedCartData = data;
        }
        
        if (updatedCartData && updatedCartData !== data) {
          
          // Check if sections are available, if not fetch them
          if (!updatedCartData.sections) {
            const sections = this.getSectionsToRender().map((section) => section.section);
            const sectionsString = [...new Set(sections)].join(',');
            try {
              const sectionsUrl = window.location.origin + `?sections=${sectionsString}`;
              const sectionsResponse = await fetch(sectionsUrl);
              if (sectionsResponse.ok) {
                updatedCartData.sections = await sectionsResponse.json();
              } else {
                return;
              }
            } catch (error) {
              return;
            }
          }
          
          // Second re-render with updated cart data (including free product)
          this.getSectionsToRender().forEach((section) => {
            const sectionEl = document.getElementById(section.id);
            if (!sectionEl) return;

            const { selector } = section;
            const el = sectionEl.querySelector(selector) || sectionEl;
            // Check if section data exists before trying to use it
            if (updatedCartData.sections && updatedCartData.sections[section.section]) {
              el.innerHTML = CartItems.getElementHTML(updatedCartData.sections[section.section], selector);
            } else {
            }
          });
          
          // Update the cart drawer count after all sections are updated
          // This ensures the count is updated even if the header was replaced
          if (this.cartDrawer) {
            this.updateCartDrawerCount(updatedCartData.item_count);
          }

          // Update the main cart page title count with updated data
          if (cartTitle && !this.cartDrawer) {
            let cartCount = cartTitle.querySelector('.cart__count');
            const updatedItemCount = updatedCartData.item_count;
            if (updatedItemCount > 0) {
              if (!cartCount) {
                cartCount = document.createElement('span');
                cartCount.className = 'cart__count';
                cartTitle.appendChild(document.createTextNode(' '));
                cartTitle.appendChild(cartCount);
              }
              cartCount.textContent = `(${updatedItemCount})`;
            } else if (cartCount) {
              cartCount.remove();
              // Remove the space before the count as well
              const lastNode = cartTitle.lastChild;
              if (lastNode && lastNode.nodeType === Node.TEXT_NODE && lastNode.textContent === ' ') {
                lastNode.remove();
              }
            }
          }

          // Check DOM after re-render
          const freebieInDOM = document.querySelector(`[data-variant-id="${this.freeProductVariantId}"]`);
          
          if (freebieInDOM) {
          } else {
          }
          
          ccEmitCartChange({
            cart: updatedCartData,
            newTotalQuantity: updatedCartData.item_count,
            newTotalPrice: updatedCartData.total_price
          });

        } else {
          // Still update drawer count with final data even if skipping second re-render
          // Use updatedCartData if it exists and has item_count, otherwise use data
          const finalCartData = updatedCartData && updatedCartData.item_count !== undefined ? updatedCartData : data;
          this.updateCartDrawerCount(finalCartData.item_count);
        }

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        window.initLazyImages();
        this.updateRecommendations(
          data.item_count > 0 ? data.items[0].product_id : null,
          data.items.slice(1).map((item) => item.product_id)
        );
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.syncCartDrawerEmptyLayout(newTotalQuantity === 0);
        this.currentTotalItemCount = newTotalQuantity;

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        // Final update to drawer count to ensure it's always correct
        // This handles cases where the count might have changed during free product handling
        const finalItemCount = updatedCartData && updatedCartData.item_count !== undefined 
          ? updatedCartData.item_count 
          : data.item_count;
        this.updateCartDrawerCount(finalItemCount);

        // The sections were re-rendered above, so re-query the error element rather than
        // reusing the pre-render reference (which is now detached, and may be null).
        const renderedLineErrors = document.getElementById(lineErrorsId)
          || document.querySelector(`[data-line-key="${line}"] .cart-item__error`);

        if (renderedLineErrors) {
          if (acceptedQuantity !== null) {
            renderedLineErrors.textContent = theme.strings.cartQtyError.replace(
              '[quantity]',
              acceptedQuantity
            );
            renderedLineErrors.hidden = false;
          } else {
            renderedLineErrors.innerHTML = '';
            renderedLineErrors.hidden = true;
          }
        }
      } catch (error) {

        // Shopify rejects requests with no valid id or line — silently refresh instead of alarming the user
        if (typeof error.message === 'string' && error.message.toLowerCase().includes('no valid id or line')) {
          this.refreshCartItems();
          return;
        }

        // Only set error message if error element exists
        if (lineErrorsElement) {
          if (/^[0-9]+$/.test(error.message)) {
            lineErrorsElement.textContent = theme.strings.cartError;
          } else {
            lineErrorsElement.textContent = error.message;
          }
          lineErrorsElement.hidden = false;
        }

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        if (input) {
          input.value = input.dataset.initialValue;
          input.closest('quantity-input').currentQty = input.dataset.initialValue;
        }
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refreshCartItems() {
      const _rciLog = (step) => {
        const ms = window.__atcT0 ? ` (+${(performance.now() - window.__atcT0).toFixed(0)}ms)` : '';
      };
      _rciLog('refreshCartItems START');
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        // FIX: fire sections + /cart.js in parallel — they're independent requests
        _rciLog('sections + cart.js fetch START (parallel)');
        const sectionsPromise = fetch(`?sections=${[...new Set(sections)]}`);
        const cartJsonPromise = CartItems.fetchCartJson();

        const response = await sectionsPromise;
        _rciLog('sections fetch DONE (status ' + response.status + ')');

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refreshCartDrawer(true);
          return;
        }

        if (!response.ok) throw new Error(response.status);

        const [data, cartData_parallel] = await Promise.all([response.json(), cartJsonPromise]);
        _rciLog('cart.js fetch DONE');

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);

          if (section.id === 'cart-items') {
            const isEmpty = !!el.querySelector('.js-cart-empty');
            el.setAttribute('data-empty', isEmpty);
            if (this.cartDrawer) {
              this.syncCartDrawerEmptyLayout(isEmpty);
            }
          }
        });

        let cartData = null;
        try {
          const cartData_ = cartData_parallel; // already fetched in parallel above
          if (cartData_) {
            cartData = cartData_;
            if (window.ccPublishCartSnapshot) {
              window.ccPublishCartSnapshot(cartData, 'refreshCartItems');
            }
            if (this.cartDrawer) {
              this.updateCartDrawerCount(cartData.item_count);
            }
            // FIX: skip redundant check if one ran in the last 5s (already ran pre-refresh)
            const _msSinceFreebie = Date.now() - (window.__lastFreebieCheckMs || 0);
            if (_msSinceFreebie < 5000) {
              _rciLog(`free product check SKIPPED — last ran ${_msSinceFreebie}ms ago`);
            } else {
              _rciLog('free product check (2nd pass) START');
              await this.checkAndHandleFreeProductImmediately(cartData);
              _rciLog('free product check (2nd pass) DONE');
            }
          }
        } catch (error) {
        }

        const cartItemEls = Array.from(this.querySelectorAll('.cart-item'));
        this.updateRecommendations(
          cartItemEls.length ? cartItemEls[0].dataset.productId : null,
          cartItemEls.slice(1).map((el) => el.dataset.productId)
        );

        if (cartData) {
          CartItems.syncCartItemDebug(cartData, this, 'refreshCartItems');
          ccEmitCartChange({ cart: cartData, cartUpdated: true, source: 'refreshCartItems' });
        }

        window.initLazyImages();

        errors.innerHTML = '';
        errors.hidden = true;
        _rciLog('refreshCartItems DONE');
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-drawer-predict-widget',
            section: cartDrawerId,
            selector: '#cart-drawer-predict-widget'
          },
          {
            id: 'cart-drawer-progress-bar',
            section: cartDrawerId,
            selector: '#cart-drawer-progress-bar'
          },
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];

        // Append any quick order lists to the sections
        document.querySelectorAll('quick-order-list').forEach((quickOrderList) => {
          const closestSection = quickOrderList.closest('.shopify-section');
          if (closestSection) {
            const sectionId = closestSection.id.replace('shopify-section-', '');
            sections.push({
              id: `quick-order-list_${sectionId}`,
              section: sectionId,
              selector: `#quick-order-list_${sectionId}`
            });
          }
        });
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-page-predict-widget',
            section: this.dataset.section,
            selector: '#cart-page-predict-widget'
          },
          {
            id: 'cart-page-progress-bar',
            section: this.dataset.section,
            selector: '#cart-page-progress-bar'
          },
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      // Find loader by line key if line is a string, otherwise by index
      let loader = null;
      if (typeof line === 'string') {
        // Line is a key, find by data-line-key attribute
        const lineItem = this.querySelector(`[data-line-key="${line}"]`);
        if (lineItem) {
          loader = lineItem.querySelector('.cart-item__loader');
        }
      } else {
        // Line is an index, find by ID
        loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      }
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    async updateRecommendations(productId, fallbackProductIds = []) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) {
        return;
      }

      if (!productId) {
        this.recommendations.innerHTML = '';
        this.recommendations.style.display = 'none';
        return;
      }

      // Recommendations are seeded from a single cart product, and any recommendation already in the
      // cart is filtered out of the render. Adding a product from this very section therefore both
      // re-seeds off the new item and shrinks the candidate pool, which could empty the list and
      // hide the section for good. Walk the rest of the cart for a seed that still yields products
      // before giving up and hiding.
      const seeds = [productId, ...fallbackProductIds].filter(
        (id, index, all) => id && all.indexOf(id) === index
      );

      const previousHTML = this.recommendations.innerHTML;
      const previousCount = this.countRecommendationProducts();

      for (const seed of seeds) {
        try {
          const response = await fetch(`${this.recommendations.dataset.url}&product_id=${seed}`);
          if (!response.ok) throw new Error(response.status);

          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          const el = tmpl.content.querySelector('product-recommendations');
          if (!el || !el.hasChildNodes()) continue;

          this.recommendations.innerHTML = el.innerHTML;

          if (this.countRecommendationProducts() === 0) continue;

          this.recommendations.dataset.productId = seed;
          this.recommendations.style.display = '';
          window.initLazyImages();
          return;
        } catch (error) {
          // Try the next seed.
        }
      }

      // No seed produced anything renderable. Keep whatever was on screen rather than blanking the
      // section, and only hide it if there was nothing there to begin with.
      this.recommendations.innerHTML = previousHTML;
      this.recommendations.style.display = previousCount === 0 ? 'none' : '';
      if (previousCount > 0) window.initLazyImages();
    }

    /**
     * Count total products in recommendations
     * @returns {number} Number of products
     */
    countRecommendationProducts() {
      if (!this.recommendations) return 0;
      
      // Try multiple selectors
      let items = this.recommendations.querySelectorAll('.slider__item');
      if (items.length === 0) {
        items = this.recommendations.querySelectorAll('ul[role="list"] > li');
      }
      
      return items.length;
    }

    /**
     * Get product IDs from recommendations
     * @returns {Array} Array of product IDs
     */
    getRecommendationProductIds() {
      if (!this.recommendations) return [];
      
      let items = this.recommendations.querySelectorAll('.slider__item');
      if (items.length === 0) {
        items = this.recommendations.querySelectorAll('ul[role="list"] > li');
      }
      
      return Array.from(items).map((item, index) => {
        const card = item.querySelector('[data-product-id]');
        return card ? card.dataset.productId : `item-${index}`;
      });
    }

    /**
     * Check and set recommendations visibility on page load
     */
    checkRecommendationsVisibility() {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) {
        return;
      }

      const count = this.countRecommendationProducts();

      if (count === 0) {
        this.recommendations.style.display = 'none';
      } else {
        this.recommendations.style.display = '';
      }
    }

    /**
     * Observe recommendations element for content changes
     */
    observeRecommendations() {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      // Create a MutationObserver to watch for changes in the recommendations element
      const observer = new MutationObserver(() => {
        const count = this.countRecommendationProducts();
        
        if (count === 0) {
          this.recommendations.style.display = 'none';
        } else {
          this.recommendations.style.display = '';
        }
      });

      // Start observing for child list changes
      observer.observe(this.recommendations, {
        childList: true,
        subtree: true
      });

      // Store observer reference for cleanup if needed
      this.recommendationsObserver = observer;
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      // `line` is normally a line key (contains ':'), not an index, so resolve it the same way
      // updateQuantity does. Looking it up as an id fails for keys, which used to drop us into the
      // "focus the first item" fallback and leave a focus ring on an unrelated product's name.
      const lineItem = document.getElementById(`cart-item-${line}`)
        || document.querySelector(`[data-line-key="${line}"]`);
      let activeEl;

      if (lineItem) {
        // `name` comes from document.activeElement, which is <body> when the input was committed by
        // blurring rather than by clicking +/-. Fall back to the line's own quantity input so focus
        // stays on the row the customer just edited.
        activeEl = (name ? lineItem.querySelector(`[name="${name}"]`) : null)
          || lineItem.querySelector('.qty-input__input');
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  // Define static helpers before customElements.define — define() upgrades existing
  // <cart-items> nodes synchronously, so init() can run before later assignments.
  CartItems.fetchCartJson = function() {
    if (!CartItems._cartFetchPromise) {
      CartItems._cartFetchPromise = fetch(`${theme.routes.cart}.js`)
        .then(r => r.json())
        .finally(() => { CartItems._cartFetchPromise = null; });
    }
    return CartItems._cartFetchPromise;
  };

  CartItems.escapeHtml = function(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  CartItems.renderLineItemProperties = function(cart, root) {
    if (!cart || !Array.isArray(cart.items)) return;
    var scope = root && root.querySelectorAll ? root : document;
    cart.items.forEach(function(item) {
      if (!item || !item.key) return;
      var row = scope.querySelector('.cart-item[data-line-key="' + CSS.escape(item.key) + '"]');
      if (!row) return;
      var el = row.querySelector('[data-line-item-properties]');
      if (!el) return;

      var props = item.properties || {};
      var keys = Object.keys(props);
      if (!keys.length) {
        el.innerHTML = '<p class="m-0 cart-item__line-properties-empty">No line item properties</p>';
        return;
      }

      var html = '<dl class="m-0">';
      keys.forEach(function(key) {
        var val = props[key];
        html += '<div class="cart-item__property">';
        html += '<dt class="inline"><strong>' + CartItems.escapeHtml(key) + ':</strong></dt>';
        html += '<dd class="inline m-0">';
        if (val == null || val === '') {
          html += '<em>(blank)</em>';
        } else if (String(val).indexOf('/uploads/') !== -1) {
          var fileName = String(val).split('/').pop();
          html += '<a href="' + CartItems.escapeHtml(val) + '">' + CartItems.escapeHtml(fileName) + '</a>';
        } else {
          html += CartItems.escapeHtml(val);
        }
        html += '</dd></div>';
      });
      html += '</dl>';
      el.innerHTML = html;
    });
  };

  CartItems._logCartDebounce = null;

  CartItems.logCartItemDetails = function(cart, source, root) {
    clearTimeout(CartItems._logCartDebounce);
    CartItems._logCartDebounce = setTimeout(function() {
      CartItems._logCartItemDetailsNow(cart, source, root);
    }, 300);
  };

  CartItems._logCartItemDetailsNow = function(cart, source, root) {
    if (!cart || !Array.isArray(cart.items)) return '';
    var scope = root && root.querySelectorAll ? root : document;
    var ts = new Date().toISOString();
    var enriched = cart.items.map(function(item, index) {
      var row = item.key
        ? scope.querySelector('.cart-item[data-line-key="' + CSS.escape(item.key) + '"]')
        : null;
      var fulfillmentEl = row ? row.querySelector('[data-line-item-fulfillment-status]') : null;
      var propertiesEl = row ? row.querySelector('[data-line-item-properties]') : null;

      return {
        line: index + 1,
        key: item.key,
        id: item.id,
        title: item.title,
        product_title: item.product_title,
        variant_title: item.variant_title,
        variant_id: item.variant_id,
        product_id: item.product_id,
        sku: item.sku,
        handle: item.handle,
        url: item.url,
        quantity: item.quantity,
        price: item.price,
        original_price: item.original_price,
        discounted_price: item.discounted_price,
        final_price: item.final_price,
        line_price: item.line_price,
        original_line_price: item.original_line_price,
        final_line_price: item.final_line_price,
        total_discount: item.total_discount,
        properties: item.properties || {},
        selling_plan_allocation: item.selling_plan_allocation || null,
        fulfillment_service: item.fulfillment_service,
        requires_shipping: item.requires_shipping,
        taxable: item.taxable,
        gift_card: item.gift_card,
        grams: item.grams,
        vendor: item.vendor,
        product_type: item.product_type,
        product_has_only_default_variant: item.product_has_only_default_variant,
        variant_options: item.variant_options || [],
        options_with_values: item.options_with_values || [],
        discounts: item.discounts || [],
        line_level_discount_allocations: item.line_level_discount_allocations || [],
        line_level_total_discount: item.line_level_total_discount,
        featured_image: item.featured_image,
        image: item.image,
        dom_fulfillment_type: fulfillmentEl ? fulfillmentEl.getAttribute('data-fulfillment-type') : null,
        dom_fulfillment_text: fulfillmentEl
          ? fulfillmentEl.textContent.replace(/\s+/g, ' ').trim()
          : null,
        dom_line_properties_text: propertiesEl
          ? propertiesEl.textContent.replace(/\s+/g, ' ').trim()
          : null,
        raw_item: item
      };
    });

    var payload = {
      source: source || 'cart',
      timestamp: ts,
      item_count: cart.item_count,
      items_subtotal_price: cart.items_subtotal_price,
      total_price: cart.total_price,
      total_discount: cart.total_discount,
      attributes: cart.attributes || {},
      note: cart.note || '',
      items: enriched
    };

    var copyText = JSON.stringify(payload, null, 2);
    console.group('[Cart] Item details — ' + (source || 'cart') + ' @ ' + ts);
    console.log('Copy/paste block:\n' + copyText);
    enriched.forEach(function(entry) {
      console.log('--- Line ' + entry.line + ': ' + (entry.title || entry.product_title || 'Item') + ' ---');
      console.log(entry);
    });
    console.groupEnd();

    return copyText;
  };

  CartItems.syncCartItemDebug = function(cart, root, source) {
    CartItems.renderLineItemProperties(cart, root);
    CartItems.logCartItemDetails(cart, source, root);
  };

  window.ccLogCartDetails = function() {
    return CartItems.fetchCartJson().then(function(cart) {
      var root = document.querySelector('cart-items');
      return CartItems._logCartItemDetailsNow(cart, 'manual', root);
    });
  };

  customElements.define('cart-items', CartItems);
}